var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#8100D9",
    fillOpacity: 0.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.186 47.456c-7.258 0-10.488-6.574-10.488-13.11s3.23-13.072 10.488-13.072c7.22 0 10.488 6.536 10.488 13.072s-3.268 13.11-10.488 13.11zm0-4.788c3.61 0 4.978-3.648 4.978-8.322 0-4.674-1.368-8.284-4.978-8.284-3.648 0-5.016 3.61-5.016 8.284 0 4.674 1.368 8.322 5.016 8.322zM51.081 47h-5.396V28.608l-4.218 4.294-3.078-3.23 7.98-8.018h4.712V47z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/Number1.6a91ef3b2166c3600135f7a046872f7f.svg";
export { ForwardRef as ReactComponent };